import { render } from "./UiDocumentReadOnly.pug?vue&type=template&id=6b9397ea&lang=pug"
import script from "./UiDocumentReadOnly.js?vue&type=script&lang=js"
export * from "./UiDocumentReadOnly.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__